import React, { useEffect, useState } from "react";
import { FormSelect } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import useCurrentUser from "shared/hook/useCurrentUser";

const SelectIndicatorsDatasetKeyin = (props) => {
  const { token } = useToken();
  const {
    placeholder,
    name,
    onChange,
    value,
    invalid,
    agencyId,
    onBlur,
    disabled,
    userId
  } = props;
  const [indicatorsData, setIndicatorsData] = useState(null);

  useEffect(() => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      params: {
        agencyId: agencyId,
        "up.upId": userId || null
      },
      show: 54,
      page: 1,
      orderBy: "indicatorsDatasetSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/tabindicatorslist`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setIndicatorsData(response.data);
      })
      .catch(function(error) {
        console.log("setting-table/tabindicatorslist", error);
      });
  }, [ agencyId, value]);

  const indicatorsNokeying = [3,4,14,40,41,45,46,47,48,49,50,51,52,53,54];

  // const indicators = [
  //   1,
  //   2,
  //   6,
  //   7,
  //   9,
  //   10,
  //   11,
  //   12,
  //   15,
  //   16,
  //   21,
  //   22,
  //   25,
  //   28,
  //   29,
  //   30,
  //   35,
  //   36,
  //   38,
  //   39,
  //   43,
  //   44,
  // ];

  return (
    <FormSelect
      placeholder={placeholder}
      name={name}
      onChange={onChange}
      value={value}
      invalid={invalid}
      onBlur={onBlur}
      disabled={disabled}
    >
      <option value="0">-เลือก-</option>
      {indicatorsData != null &&
        indicatorsData.data.length > 0 &&
        indicatorsData.data
          .filter(
            (item) => indicatorsNokeying.indexOf(item.indicatorsDatasetSettingId) == -1
          )
          .map((item, key) => (
            <option
              key={key}
              value={item.indicatorsDatasetSettingId}
              title={item.indicatorsDatasetSettingName}
            >
              {item.indicatorsDatasetSettingId} -{" "}
              {item.indicatorsDatasetSettingName}
            </option>
          ))}
    </FormSelect>
  );
};
export default SelectIndicatorsDatasetKeyin;
